var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.labels,
    ( _obj = {}, _obj[_vm.$style.compact] = _vm.compact, _obj[_vm.$style.desktop] = _vm.compact && !_vm.$device.isMobileOrTablet, _obj[_vm.$style.inline] = _vm.compact && _vm.inline, _obj ) ]},_vm._l((_vm.visibleItems),function(item,index){return _c(_vm.componentItem(item),{key:index,tag:"component",class:_vm.classItem(item),style:(_vm.styleItem(item)),attrs:{"to":_vm.componentItem(item) === 'nuxt-link' ? item.url : false,"href":_vm.componentItem(item) === 'a' || _vm.componentItem(item) === 'nuxt-link'
        ? item.url
        : false,"target":_vm.componentItem(item) === 'a' ? '_blank' : false}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }